import { getSharedConfig } from "../../createSharedConfig"
import { getBuyRequestMeta, getSimpleForBuyRequest } from "@/js/helpers/buy-request"
import { RackOptions } from "@/js/pages/product/rackbuilder/RackTypes"
import { findBundleProduct, getAccessoryQuantity } from "@/js/pages/product/rackbuilder/utils/product-lookup"
import { getCommonAccessorySelections, getBackSelection, getFrontSelection, getJCupSelection, getDepthSelection, getPlateStorageSelection, getBandPegSelection } from "@/js/pages/product/rackbuilder/utils/selection-utils"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"

export function createIndyConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const meta = getBuyRequestMeta(buyRequest, rogue)
  const rack = findBundleProduct(rogue, buyRequest, 'rack') || getSimpleForBuyRequest(buyRequest, rogue)
  const functionalTrainer = findBundleProduct(rogue, buyRequest, 'functional trainer')

  const sharedConfig = getSharedConfig(rogue, buyRequest)

  const leftSide = functionalTrainer?.attributes?.side === 'Left' || functionalTrainer?.attributes?.side === 'Dual'
  const rightSide = functionalTrainer?.attributes?.side === 'Right' || functionalTrainer?.attributes?.side === 'Dual'
  const isIndyHalfRack = rack?.attributes?.rack_size === '4'
  const frontStabilizer = isIndyHalfRack && findBundleProduct(rogue, buyRequest, 'feet', true) !== undefined
  const is80Height = sharedConfig.height === '80'

  const { trolleySelection } = getCommonAccessorySelections(rogue, buyRequest, sharedConfig.materials || {})

  return {
    ...sharedConfig,
    back         : is80Height ? 'crossmember top 4' : getBackSelection(rogue, buyRequest, meta) || 'nameplate',
    front        : is80Height ? 'offset' : getFrontSelection(rogue, buyRequest, meta),
    edition      : 'indy',
    jcup         : getJCupSelection(rogue, buyRequest),
    depth        : getDepthSelection(rack, meta),
    halfRack     : isIndyHalfRack || undefined,
    sixPost      : !isIndyHalfRack,
    plateStorage : getPlateStorageSelection(rogue, buyRequest),
    bandPegs     : getBandPegSelection(rogue, buyRequest),
    ftShrouds    : Boolean(functionalTrainer && functionalTrainer?.attributes?.rig_or_wm !== 'No'),
    spotterArms  : getAccessoryQuantity(rogue, buyRequest, 'spotter arms'),
    leftSide,
    rightSide,
    frontStabilizer,
    trolleySelection,
  }
}
